import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App";
import "./index.css";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  // Tunnel via notre domaine : contourne les bloqueurs de pub qui bloquent
  // ingest.sentry.io (rewrite Vercel /monitoring/* → ingest.de.sentry.io/*).
  tunnel: "/monitoring",
  // Erreurs uniquement : pas de tracing ni de Session Replay
  // (quota gratuit 5 000 erreurs/mois).
  tracesSampleRate: 0,
  // Même projet Sentry que le storefront : ce tag permet de filtrer
  // les erreurs de l'admin dans le dashboard (app = "admin-panel").
  initialScope: { tags: { app: "admin-panel" } },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary
    fallback={
      <div style={{ padding: "2rem", textAlign: "center", fontFamily: "sans-serif" }}>
        <h1>Une erreur est survenue</h1>
        <p>Recharge la page. Si le problème persiste, contacte le support.</p>
      </div>
    }
  >
    <App />
  </Sentry.ErrorBoundary>
);
